var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GalleryThumbnail',{attrs:{"image":_vm.image,"size":_vm.size,"top-left-action":_vm.topLeftAction,"top-right-action":_vm.topRightAction,"bottom-left-action":_vm.bottomLeftAction},on:{"mouseenter":function($event){return _vm.$emit('mouseenter')},"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }